/** @format */

import { ElMessage as Message } from 'element-plus';
import { $utils } from '@/utils/publicUtils';

const common = {
	PAGE: 1,
	LIMIT: 20,
};

const ActionUtils = {
	warning(message) {
		this.msg(message, {
			type: 'warning',
		});
	},
	msg(message, options) {
		Message.closeAll();
		if (!options) {
			options = options || {};
		}
		options.message = message;
		Message(options);
	},
	/**
	 * 格式分页数据
	 * @param {} params 查询的参数
	 * @param {} pagination 分页
	 * @param {} sorts 排序
	 */
	formatParams(params, pagination, sorts) {
		const results = {};
		if (params) {
			results.parameters = Object.keys(params).map((k) => {
				const paramValue = params[k];
				if ($utils.isObject(paramValue) && paramValue['relation']) {
					return paramValue;
				} else {
					return {
						code: k,
						value: paramValue,
					};
				}
			});
		}
		if (pagination) {
			results.requestPage = {
				pageNo: pagination.page || common.PAGE,
				limit: pagination.limit || common.LIMIT,
			};
			if ($utils.isNotEmpty(pagination.totalCount)) {
				// mock 数据时候要传
				results.requestPage['totalCount'] = pagination.totalCount;
			}
		}
		if (sorts) {
			results.sorts = Object.keys(sorts).map((k) => {
				return {
					field: k,
					order: sorts[k],
				};
			});
		}
		return results;
	},
};

export { ActionUtils };
